import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'

// 开箱
import Index from '@/views/Index/Index.vue'
import Openbox from '@/views/Index/openbox.vue'
import TaskCenter from '@/views/Index/task-center.vue'


// 个人中心
import Personal from '@/views/me/personal.vue'
import Inform from '@/views/me/inform.vue'
import Retrieve from '@/views/me/retrieve.vue'


// 商城
import Shoping from '@/views/shopping/shoping.vue'

// rool
import Roll from '@/views/roll/roll.vue'
import Room from '@/views/roll/room.vue'

// 逐鹿之战
import Fight from '@/views/fight/fight.vue'
import FightAdd from '@/views/fight/add.vue'
import FightRoom from '@/views/fight/room.vue'
import FightHistory from '@/views/fight/history.vue'

// 幸运饰品
import Lucky from '@/views/lucky/lucky.vue'
import LuckyOpen from '@/views/lucky/open.vue'
import LuckyHistory from '@/views/lucky/history.vue'
import LuckyRule from '@/views/lucky/rule.vue'
// 升级
import Upgrade from '@/views/upgrade/upgrade.vue'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: "index",
    children: [{
      path: 'index',
      name: 'Index',
      title: '首页',
      component: Index,
      children: []
    },
    {
      path: '/fight',
      name: 'Fight',
      title: '逐鹿之战',
      component: Fight
    }, {
      path: '/fight/room',
      name: 'FightRoom',
      title: '对战房间详情',
      component: FightRoom
    },
    {
      path: '/fight/add',
      name: 'FightAdd',
      title: '新增对战',
      component: FightAdd
    },
    {
      path: '/fight/history',
      name: 'FightHistory',
      title: '对战历史',
      component: FightHistory
    }, {
      path: '/roll',
      name: 'Roll',
      title: 'ROLL房',
      component: Roll
    }, {
      path: '/roll/room',
      name: 'Room',
      title: 'roll房间',
      component: Room
    }, {
      path: '/upgrade',
      name: 'Upgrade',
      title: '幸运饰品',
      component: Upgrade
    }, {
      path: '/lucky',
      name: 'Lucky',
      title: '幸运饰品',
      component: Lucky
    }, {
      path: '/lucky/open',
      name: 'LuckyOpen',
      component: LuckyOpen
    }, {
      path: '/lucky/history',
      name: 'LuckyHistory',
      component: LuckyHistory
    }, {
      path: '/lucky/rule',
      name: 'LuckyRule',
      component: LuckyRule
    }, {
      path: '/shoping',
      name: 'Shoping',
      title: '商城',
      component: Shoping
    }, {
      path: '/index/task-center',
      name: 'TaskCenter',
      title: '签到',
      component: TaskCenter
    }, {
      path: '/index/openbox',
      name: 'Openbox',
      title: '新人宝箱',
      component: Openbox,
    }, {
      path: '/me/retrieve',
      name: 'Retrieve',
      title: '取回列表',
      component: Retrieve
    }, {
      path: '/me/inform',
      name: 'Inform',
      title: '消息通知',
      component: Inform
    }, {
      path: '/personal',
      name: 'Personal',
      title: '个人中心',
      component: Personal
    }]
  },
]

const router = new VueRouter({
  routes
})


export default router
